import React from 'react';

const LogoTile = ({ src, alt, sizeClass = 'h-36 w-36', className = '' }) => {
  return (
    <div className={`logoHero relative flex items-center justify-center ${className}`}>
      <div className="logoTile rounded-2xl shadow-[0_0_10px_-6px_rgba(147,51,234,0.22)]">
        <img src={src} alt={alt} className={`relative z-10 ${sizeClass}`} />
      </div>
    </div>
  );
};

export default LogoTile;
